export const ENV_DEFAULTS = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string) || 'http://localhost:5000/api/v1',
  envLabel: (import.meta.env.VITE_ENV_LABEL as string) || 'Local Dev',
}
